import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/constants';
import { ALERT_POLL_TIMER } from '@app/shared/constants/globalConstants';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { AlertResponse, AppAlert } from './alerts.model';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private readonly dismissedAlertKeyPrefix = 'alert-dismissed';
  private readonly alertsSubject = new BehaviorSubject<AppAlert[]>([]);
  readonly alerts$ = this.alertsSubject.asObservable();
  readonly visibleAlerts$: Observable<AppAlert[]> = this.alerts$.pipe(
    map(alerts =>
      [...alerts]
        .filter(alert => !this.isDismissed(alert.alertId))
        .sort((a, b) => b.severity - a.severity)
    )
  );

  constructor(private readonly http: HttpClient) {}

  startPolling(portalAccountId: number): Observable<AlertResponse> {
    return timer(0, ALERT_POLL_TIMER).pipe(
      switchMap(() => this.getAlerts(portalAccountId)),
      tap(response => this.alertsSubject.next(response.alertList ?? []))
    );
  }

  dismiss(alertId: number): void {
    sessionStorage.setItem(this.getDismissedKey(alertId), 'true');
    this.alertsSubject.next([...this.alertsSubject.value]);
  }

  private getAlerts(portalAccountId: number): Observable<AlertResponse> {
    return this.http.get<AlertResponse>(
      `${Constants.appConfiguration.apiRoot}/Alert/${portalAccountId}`
    );
  }

  private isDismissed(alertId: number): boolean {
    return sessionStorage.getItem(this.getDismissedKey(alertId)) === 'true';
  }

  private getDismissedKey(alertId: number): string {
    return `${this.dismissedAlertKeyPrefix}-${alertId}`;
  }
}
